var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOtherWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6951 14.5099H21.1972V18.0119H24.6992V21.514H21.1972V25.016H17.6951V21.514H14.1931V18.0119H17.6951V14.5099Z",
    fill: "#29CC6A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_22219_366515",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00189209,
    y: 0.391846,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00189209,
    y: 0.391846,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421,
    stroke: "#0096FF",
    strokeWidth: 5.22973,
    mask: "url(#path-2-inside-1_22219_366515)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_22219_366515",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00189209,
    y: 14.2133,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.00189209,
    y: 14.2133,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421,
    stroke: "#FFC814",
    strokeWidth: 5.22973,
    mask: "url(#path-3-inside-2_22219_366515)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_22219_366515",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.8195,
    y: 0.391846,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8195,
    y: 0.391846,
    width: 11.2066,
    height: 11.2066,
    rx: 1.49421,
    stroke: "#FF3296",
    strokeWidth: 5.22973,
    mask: "url(#path-4-inside-3_22219_366515)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtherWallet);
export default __webpack_public_path__ + "static/media/ic_otherWallet.477cae102275579115bb34f7d96d6fd9.svg";
export { ForwardRef as ReactComponent };